<script setup>
  import { ref, computed, onMounted, watchEffect } from 'vue';
  import BaseModal from './base/BaseModal.vue';
  import Icon from '@/components/icons/Icon.vue';
  import AlertDevicesManageContent from './AlertDevicesManageContent.vue';

  const emits = defineEmits(['close']);

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    }
  });

  const showModal = ref(false);
  const contentRef = ref(null);

  const isAtRoot = computed(() => contentRef.value?.isAtRoot ?? true);
  const title = computed(() => contentRef.value?.title ?? 'Devices');
  const submitLabel = computed(() => contentRef.value?.submitLabel ?? '');
  const errorCount = computed(() => contentRef.value?.errorCount ?? 0);

  function handleBack() {
    contentRef.value?.back();
  }

  async function handleSubmit() {
    await contentRef.value?.submit();
  }

  function closeModal() {
    showModal.value = false;
    contentRef.value?.back();
    emits('close');
  }

  onMounted(() => {
    watchEffect(() => {
      showModal.value = props.show;
    });
  });
</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="true"
    height="tall"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">
        <button v-if="!isAtRoot" type="button" class="jwx-modal__back-button" @click="handleBack">
          <Icon name="chevron-left" />
        </button>
        {{ title }}
      </h2>
    </header>

    <div class="jwx-modal__body">
      <AlertDevicesManageContent ref="contentRef" />
    </div>

    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          v-if="isAtRoot"
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Done
        </button>
        <button
          v-else
          type="button"
          @click.prevent="handleSubmit"
          class="jwx-button"
        >
          {{ submitLabel }}
          <span v-if="errorCount > 0" class="jwx-button__error-pill">{{ errorCount }} {{ errorCount === 1 ? 'Error' : 'Errors' }}</span>
        </button>
      </div>
    </div>
  </BaseModal>
</template>
